import { render, staticRenderFns } from "./claimAnInterest.vue?vue&type=template&id=04a3f7d0&scoped=true&"
import script from "./claimAnInterest.vue?vue&type=script&lang=js&"
export * from "./claimAnInterest.vue?vue&type=script&lang=js&"
import style0 from "./claimAnInterest.vue?vue&type=style&index=0&id=04a3f7d0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a3f7d0",
  null
  
)

export default component.exports